import { Controller } from "@hotwired/stimulus"
import { copyHtmlAndText } from "../util/clipboard"

const COPIED_FEEDBACK_TIMEOUT_MS = 2000

export default class extends Controller {
  static targets = [
    "copyHeader",
    "sendSection",
    "copyButton",
    "sendButton",
    "notificationInput",
    "selectExternalCheckbox",
    "selectInternalCheckbox",
    "speakerCheckbox",
    "speakerRow"
  ]

  connect() {
    this.syncAllTypeCheckboxStates()
    this.syncSendButtonState()
  }

  selectMode(event) {
    const isSendViaTap = event.target.value === "send_via_tap"

    this.copyHeaderTarget.classList.toggle("hidden", isSendViaTap)
    this.sendSectionTarget.classList.toggle("hidden", !isSendViaTap)
    this.copyButtonTarget.classList.toggle("hidden!", isSendViaTap)
    this.sendButtonTarget.classList.toggle("hidden!", !isSendViaTap)
  }

  toggleSpeakersByType(event) {
    const shouldCheck = event.target.checked
    event.target.indeterminate = false

    this.speakerCheckboxesByType(event.target.dataset.speakerType).forEach(checkbox => {
      checkbox.checked = shouldCheck
    })

    this.syncSendButtonState()
  }

  syncTypeSelectionState(event) {
    this.syncTypeCheckboxState(event.target.closest("[data-speaker-join-instructions-target='speakerRow']").dataset.speakerType)
    this.syncSendButtonState()
  }

  async copyTemplate(event) {
    event.preventDefault()

    const html = this.notificationInputTarget.value || ""

    try {
      await copyHtmlAndText(html, this.htmlToText(html))
      this.showCopiedFeedback()
    } catch (error) {
      console.error("Copy failed:", error)
    }
  }

  get typeCheckboxes() {
    return [ this.selectExternalCheckboxTarget, this.selectInternalCheckboxTarget ]
  }

  htmlToText(html) {
    const div = document.createElement("div")
    div.innerHTML = html
    return div.textContent.trim()
  }

  showCopiedFeedback() {
    const button = this.copyButtonTarget
    const originalText = button.textContent
    button.textContent = "Copied!"
    setTimeout(() => { button.textContent = originalText }, COPIED_FEEDBACK_TIMEOUT_MS)
  }

  speakerCheckboxesByType(speakerType) {
    return this.speakerCheckboxTargets.filter(checkbox => this.speakerRowFor(checkbox).dataset.speakerType === speakerType)
  }

  speakerRowFor(checkbox) {
    return checkbox.closest("[data-speaker-join-instructions-target='speakerRow']")
  }

  syncTypeCheckboxState(speakerType) {
    const typeCheckbox = this.typeCheckboxFor(speakerType)
    if (!typeCheckbox) return

    const speakerCheckboxes = this.speakerCheckboxesByType(speakerType)
    const total = speakerCheckboxes.length
    const checked = speakerCheckboxes.filter(checkbox => checkbox.checked).length

    typeCheckbox.checked = total > 0 && checked === total
    typeCheckbox.indeterminate = checked > 0 && checked < total
  }

  syncAllTypeCheckboxStates() {
    this.typeCheckboxes.forEach(checkbox => this.syncTypeCheckboxState(checkbox.dataset.speakerType))
  }

  syncSendButtonState() {
    const hasSelectedSpeaker = this.speakerCheckboxTargets.some(checkbox => checkbox.checked)
    this.sendButtonTarget.disabled = !hasSelectedSpeaker
  }

  typeCheckboxFor(speakerType) {
    return this.typeCheckboxes.find(checkbox => checkbox.dataset.speakerType === speakerType)
  }
}
